import { Component, input, InputSignal } from '@angular/core';
import { AmlScanEntity, IngoingTransaction, LatestAmlReport } from '../../../../../../../api/api.model';
import { DatePipe, DecimalPipe, LowerCasePipe, NgClass, NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { CopyButtonComponent } from '../../../../../copy-button/copy-button.component';
import { MatIconModule } from '@angular/material/icon';
import { CropWithDotsCenterPipe } from '../../../../../../pipes/crop-with-dots-center.pipe';
import { InfoComponent } from '../../../../../info/info.component';
import { TriggerIdConvertToCategoryPipe } from '../../../../../../pipes/trigger-id-convert-to-category.pipe';
import { ReportStatusComponent } from '../../../../../report-status/report-status.component';
import { ConvertNetworkToTokenPipe } from '../../../../../../pipes/convert-netwrok-to-token.pipe';
import { CutNumberPipe } from "../../../../../../pipes/cut-number.pipe";

@Component({
  selector: 'app-transaction-scan',
  imports: [
    DatePipe,
    NgOptimizedImage,
    CopyButtonComponent,
    NgClass,
    CropWithDotsCenterPipe,
    LowerCasePipe,
    InfoComponent,
    TitleCasePipe,
    ReportStatusComponent,
    MatIconModule,
    TriggerIdConvertToCategoryPipe,
    ConvertNetworkToTokenPipe,
    CutNumberPipe
],
  templateUrl: './transaction-scan.component.html',
  styleUrl: './transaction-scan.component.scss'
})
export class TransactionScanComponent {
  public readonly transaction: InputSignal<AmlScanEntity<LatestAmlReport>> = input.required();

  ngOnInit(): void {
    console.log(this.transaction());
  }

  public asIngoingTransaction(transaction: AmlScanEntity<LatestAmlReport>): AmlScanEntity<IngoingTransaction> {
    return transaction as AmlScanEntity<IngoingTransaction>;
  }

  public calcPercentForExposures(value: number): number {
    return Math.round((value / this.transaction().amount) * 100 * 100) / 100;
  }

}
